import { mixed, object, string } from 'yup';
import { CreditCardType } from '../../../../payment/domain/models';
import { IBookingPaymentDetails } from './IBooking';
import { IPrice } from '../../../../shared/i18n/price/IPrice';

export const bookingPaymentDetailsSchema = object<IBookingPaymentDetails>({
	token: string().optional(),
	total: mixed<IPrice>().required(),
	creditCardType: mixed<CreditCardType>()
		.transform((value: unknown) =>
			typeof value === 'string' ? value.toUpperCase() : value,
		)
		.oneOf(Object.values(CreditCardType))
		.optional(),
	maskedCreditCardNumber: string().optional(),
}).required();
